import { Group, Stack, Text, Title, useMantineTheme } from "@mantine/core"
import _ from "lodash"
import { Element, Link } from "react-scroll"

import { FindFaqByLanguageResponseDto } from "~/gen/api"
import { FAQ_CATEGORIES } from "~/pages/Brand/FAQ/constants.ts"

type Props = {
  faqs: FindFaqByLanguageResponseDto[]
}

export const FAQContent = ({ faqs }: Props) => {
  const { colors } = useMantineTheme()

  const questionsByCategory = _.groupBy(
    faqs,
    (faq) => FAQ_CATEGORIES[faq.category]
  )

  const hasMultipleCategories = Object.keys(questionsByCategory).length > 1

  return (
    <Group wrap="nowrap" align="flex-start" gap="xl">
      {hasMultipleCategories && (
        <Stack gap={0} pr={24} style={{ position: "sticky", top: 90 }}>
          {_.map(questionsByCategory, (_faqs, category) => (
            <Link
              key={category}
              spy
              smooth
              offset={-80}
              to={category}
              activeStyle={{
                backgroundColor: colors.sand[0],
                fontWeight: "bold",
              }}
            >
              <Stack w={200} px="md" py="xs">
                {category}
              </Stack>
            </Link>
          ))}
        </Stack>
      )}
      <Stack>
        {_.map(questionsByCategory, (faqs, category) => {
          return (
            <Element key={category} name={category}>
              <Stack key={category} mb={40}>
                <Title order={hasMultipleCategories ? 2 : 1} mb={32}>
                  {category}
                </Title>
                {faqs.map((faq) => (
                  <Stack key={faq.id} mb={40}>
                    <Group mb={16}>
                      <Title order={3}>{faq.question}</Title>
                    </Group>
                    <Text fz="sm" style={{ whiteSpace: "pre-line" }}>
                      {faq.answer}
                    </Text>
                  </Stack>
                ))}
              </Stack>
            </Element>
          )
        })}
      </Stack>
    </Group>
  )
}
